//
//  contact.ts
//  moods-film-ui-master
//
//  Created by romainharvier@gmail.com on 10/08/2019.
//  Copyright © 2019 Moods. All rights reserved.
//

import {Vue, Component, Prop} from 'vue-property-decorator';
import EventBus from '@/utils/event-bus';

@Component
export default class Contact extends Vue {

    @Prop(String) private readonly context!: string;

    private onReturnToHomeClick(): void {

        EventBus.$emit('return-to-home');

    }

}
